import base from './base';

const list = {
  MuiListItem: {
    styleOverrides: {
      root: {},
    },
  },

  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: 0,
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: '14px',
        fontWeight: 400,
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        width: 30,
        height: 30,
        borderRadius: base.shape.borderRadius,
        marginRight: '6px',
      },
    },
  },
};
export default list;
